<template>
  <filter-group title="Colors">
    <nested-checkbox-group
      :groups="colorFamilies"
      :selected-values="selectedFilters"
      @change="emitUpdatedFilters"
    />
  </filter-group>
</template>

<script>
import { mergeColorFamilies } from '@/views/apps/retailer-ai/utils'
import FilterGroup from './FilterGroup.vue'
import NestedCheckboxGroup from './NestedCheckboxGroup.vue'

export default {
  name: 'ColorFamilyFilter',
  components: {
    FilterGroup,
    NestedCheckboxGroup,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    selectedFilters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      colorFamilies: [],
      expandedColorFamilies: new Set(),
    }
  },
  watch: {
    products: {
      handler(newProducts) {
        this.colorFamilies = mergeColorFamilies(this.colorFamilies, newProducts, this.expandedColorFamilies)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    emitUpdatedFilters(updatedFilter) {
      this.$emit('filters-changed', updatedFilter)
    },
  },
}
</script>
